"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=intersect_of_props.js.map